import React, { useState, useEffect } from 'react';
import { getSettings, updateSettings } from '../../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import SettingsForm from '../forms/SettingsForm';
import toast from 'react-hot-toast';

const SettingsModule = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await getSettings();
      console.log('Settings response:', response);
      
      // Handle nested response structure
      let settingsData = {};
      if (response && response.data) {
        // If response has data property
        if (response.data.data) {
          // Nested data (like your API response)
          settingsData = response.data.data || response.data;
        } else {
          settingsData = response.data;
        }
      } else if (response) {
        settingsData = response;
      }
      
      setSettings(settingsData);
    } catch (error) {
      console.error('Error fetching settings:', error);
      toast.error('Error fetching settings');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data) => {
    try {
      console.log('Saving settings:', data);
      await updateSettings(data);
      toast.success('Settings updated successfully');
      await fetchSettings();
    } catch (error) {
      console.error('Error updating settings:', error);
      toast.error(error.message || 'Error updating settings');
    }
  };

  if (loading) return <LoadingSpinner message="Loading settings..." />;

  return <SettingsForm settings={settings} onSave={handleSave} />;
};

export default SettingsModule;

